export default function foo () {
	console.log( 'hello from foo.js' );
}
